export default "__VITE_ASSET__D7H$IohZ__"